"use client";

import Image from "next/image";
import Link from "next/link";
import "../../css/Footer.css";
import appStore from "../../assets/images/app-store.png";
import playStore from "../../assets/images/google-play.png";

const Footer: React.FC = () => {
  return (
    <footer className="interllekt-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <Link href="/" className="footer-logo">
            <Image
              src="/auth-white-logo.png"
              alt="CareAscendium Logo"
              width={180}
              height={50}
              priority
            />
          </Link>
          <p className="footer-mission">
            CAREASCENDIUM is more than software—it’s a partner in your
            facility’s journey toward operational excellence and
            resident-centered care.
          </p>
          <div className="app-buttons">
            <Link
              href="https://itunes.apple.com/us/app/careascend/id1276750022?mt=8&ign-mpt=uo%3D4"
              aria-label="Download on App Store"
            >
              <Image
                src={appStore}
                alt="Download on the App Store"
                width={160}
                height={48}
              />
            </Link>
            <Link
              href="https://play.google.com/store/apps/details?id=com.careascend.android"
              aria-label="Get it on Google Play"
            >
              <Image
                src={playStore}
                alt="Get it on Google Play"
                width={160}
                height={48}
              />
            </Link>
          </div>
          <p className="footer-copyright">
            © CareAscendium, LLC. | {new Date().getFullYear()} | All Rights
            Reserved.
          </p>
        </div>

        <div className="footer-social footer-social-left">
          <h4 className="connect-title">Connect</h4>
          <div className="social-icons">
            <Link
              href="https://www.linkedin.com/company/careascend"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <span className="icon-in">in</span>
            </Link>
          </div>
        </div>

        <div className="footer-legal-block">
          <Link href="/privacy-policy" className="footer-legal-link">
            PRIVACY POLICY
          </Link>
          <Link href="/terms-and-conditions" className="footer-legal-link">
            TERMS & CONDITIONS
          </Link>
          <p className="footer-powered">Powered by MavenSphere Inc.</p>
        </div>

        {/* <div className="footer-links">
          <h4>Pages</h4>
          <ul>
            <li>
              <Link href="/">Home</Link>
            </li>
            <li>
              <Link href="/about">About Us</Link>
            </li>
            <li>
              <Link href="/services">Services</Link>
            </li>
            <li>
              <Link href="/blog">Blog</Link>
            </li>
            <li>
              <Link href="/contact">Contact Us</Link>
            </li>
          </ul>
        </div> */}

        {/* <div className="footer-links">
          <h4>Services</h4>
          <ul>
            <li>
              <Link href="/coming-soon">QAPI Management</Link>
            </li>
            <li>
              <Link href="/coming-soon">
                <b>Workflow Automation</b>
              </Link>
            </li>
            <li>
              <Link href="/coming-soon">
                <b>Compliance Management</b>
              </Link>
            </li>
            <li>
              <Link href="/coming-soon">
                <b>Advanced Analytics</b>
              </Link>
            </li>
          </ul>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
